const links = [
    {
        id: 1,
        tolink: '/',
        namelink: 'Passport'
    },
    {
        id: 2,
        tolink: 'home02',
        namelink: 'Home 02'
    },
    {
        id: 3,
        tolink: 'home03',
        namelink: 'Home 03'
    },
    {
        id: 4,
        tolink: 'home04',
        namelink: 'Home 04'
    },
    {
        id: 5,
        tolink: 's175',
        namelink: 'S175'
    },
    {
        id: 6,
        tolink: 'seven360',
        namelink: 'Seven360'
    },
    {
        id: 7,
        tolink: '/original',
        namelink: 'Home Original'
    },
];


export default links ;